export default {
    chartsSectionTitle: 'custom_chart_scene_charts_section_title',
    dataTableSectionTitle: 'custom_chart_scene_data_table_section_title',
    citationText: 'custom_chart_scene_citation_text',
    naTreemapChart: 'custom_chart_scene_na_treemap_chart',
    sequelaDataNA: 'custom_chart_scene_sequela_data_na',
    treemapChartFeedback: 'custom_chart_scene_treemap_feedback',
};
